import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "@/telemetry/appInsights";

export function TelemetryProvider({ children }: { children: React.ReactNode }) {
  const location = useLocation();

  useEffect(() => {
    trackPageView(location.pathname, window.location.href);
  }, [location]);

  return <>{children}</>;
}
